import Vue from "vue";
import VueRouter from "vue-router";
import authService from "@/services/auth.service";

import SupervisorView from "@/components/supervisor/SupervisorView";
import AxisDiskStatusView from "@/components/axis/AxisDiskStatusView";
import OrdersView from "@/components/orders/OrdersView";
import OrderUpdate from "@/components/orders/Update";
import OrderDetail from "@/components/orders/Detail";
import OrderCreate from "@/components/orders/Create";

import VideoPlayerView from "@/components/orders/video-player/VideoPlayerView";
import AccessDenied from "@/components/main/CompAccessDenied";

import Login from "@/components/main/LoginView";
import Main from "@/components/main/MainView";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: {
      name: "login",
    },
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    beforeEnter: (to, from, next) => {
      if (authService.isUsingOAuth2()) {
        console.log("⚠️ Ruta /login deshabilitada con OAuth2, redirigiendo...");
        window.location.href = `/oauth2/start?rd=${encodeURIComponent(
          window.location.origin + "/orders"
        )}`;
        return;
      }
      next();
    },
  },
  {
    path: "/menu",
    name: "menu",
    component: Main,
    children: [
      {
        path: "/supervisor",
        name: "Supervisor",
        component: SupervisorView,
      },
      {
        path: "/storage",
        name: "storage",
        component: AxisDiskStatusView,
      },
      {
        path: "/orders",
        name: "Orders",
        component: OrdersView,
        children: [
          {
            path: "/orders/:id/player",
            name: "VideoPlayerView",
            component: VideoPlayerView,
            props: true,
          },
        ],
      },
      {
        name: "OrderCreate",
        path: "/orders/create",
        component: OrderCreate,
      },
      {
        name: "OrderUpdate",
        path: "/order/update/:id",
        component: OrderUpdate,
      },
      {
        name: "OrderDetail",
        path: "/order/:id",
        component: OrderDetail,
      },
      {
        path: "/denied",
        name: "AccessDenied",
        component: AccessDenied,
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
